<template>
  <div id="app" class="uk-section uk-section-default">
    <h1 class="uk-heading-line uk-text-center uk-text-bold">N O A H</h1>
    <h3 class="uk-heading-line uk-text-center">Class room Syatem</h3>
    <div class="uk-container uk-width-1-2">
      <router-view/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue